import { render, staticRenderFns } from "./StuCourse.vue?vue&type=template&id=510f8eac&scoped=true&"
import script from "./StuCourse.vue?vue&type=script&lang=js&"
export * from "./StuCourse.vue?vue&type=script&lang=js&"
import style0 from "./StuCourse.vue?vue&type=style&index=0&id=510f8eac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510f8eac",
  null
  
)

export default component.exports